module.exports = __webpack_public_path__ + "static/media/takayama.f4e0f840.webp";